import { IconButton } from "@aisquare/ui";
import { MoreVerticalIcon, XIcon, PencilIcon, TrashIcon, ChevronLeftIcon } from "lucide-react";
import { Section, VariantBlock } from "../lib/Section";

/**
 * Verification harness for IconButton — the icon-only control. It stays ROUND
 * (the Onyx hex notch is for rectangular surfaces) but shares the offset-key
 * language via the press: a springy 1px press-DOWN on :active with the same
 * overshoot bounce every Button/KeycapButton uses. Press is live here.
 */
export function IconButtonDemo() {
  return (
    <Section
      id="icon-button"
      title="IconButton"
      description="Icon-only inline control — fixed 40×40, fully-rounded, no border/fill at rest (faint accent tint on hover). Round, NOT notched (the hex notch is for rectangular surfaces), but it shares the offset-key press: a springy 1px press-DOWN on :active with the lib's overshoot bounce. Required aria-label. motion={false} opts out of the press; asChild composes onto a Link."
    >
      <VariantBlock label="Common affordances — hover + press are live" caption="kebab · close · edit · delete · back">
        <div className="flex flex-wrap items-center gap-2">
          <IconButton aria-label="More options">
            <MoreVerticalIcon />
          </IconButton>
          <IconButton aria-label="Close">
            <XIcon />
          </IconButton>
          <IconButton aria-label="Edit">
            <PencilIcon />
          </IconButton>
          <IconButton aria-label="Delete">
            <TrashIcon />
          </IconButton>
          <IconButton aria-label="Back">
            <ChevronLeftIcon />
          </IconButton>
        </div>
      </VariantBlock>

      <VariantBlock label="States" caption="disabled · motion=false (no press) · asChild as a link">
        <div className="flex flex-wrap items-center gap-2">
          <IconButton aria-label="Disabled" disabled>
            <PencilIcon />
          </IconButton>
          <IconButton aria-label="No press" motion={false}>
            <PencilIcon />
          </IconButton>
          <IconButton asChild aria-label="Open link">
            <a href="#icon-button">
              <ChevronLeftIcon />
            </a>
          </IconButton>
        </div>
      </VariantBlock>
    </Section>
  );
}
